import React from "react";
import ApolloClient from "apollo-boost";
import { ApolloProvider } from "react-apollo";
import getEnvVars from "../../../../environment";

const { graphqlUrl } = getEnvVars();

export const client = new ApolloClient({
  uri: graphqlUrl
});

export default props => {
  return (
    <ApolloProvider client={client} {...props}>
      {props.children}
    </ApolloProvider>
  );
};
